// extracted by mini-css-extract-plugin
module.exports = {"csr_pc_G":"G_csr_pc_G__fLH80"};